// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__2BrCi","black":"Input_black__7jL9_","white":"Input_white__3FznI"};